var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      key: _vm._uid,
      staticClass: "checkbox",
      class: { active: _vm.localValue },
      on: {
        click: function($event) {
          _vm.localValue = !_vm.localValue
          _vm.update()
        }
      }
    },
    [_vm.localValue ? _c("span", { staticClass: "checkmark" }) : _vm._e()]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }